<template>
  <div class="content">
    <h1 class="title">{{ $t("usageArchive.title") }}</h1>
    <v-card class="mt-10 pa-10 chart-section">
        <canvas
            id="canvas"
            :class="{
              'd-none': isLoading,
            }"
            width="500"
            height="300"
          ></canvas>
          <div class="loading" :class="{ 'd-block': isLoading }">
            <v-progress-circular
              v-if="isLoading"
              size="73.5"
              indeterminate
              class="loading-circle"
            ></v-progress-circular>
          </div>
      </v-card>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      chart: "",
      isLoading: false,
      data_count: 7,
      number_cfg: {
        count: this.data_count,
        min: -100,
        max: 100,
      },

      data: {},
    };
  },
  created() {
    this.handleGetCapacityStatistics();
  },
  mounted() {
    document.addEventListener("DOMContentLoaded", function () {
      const ctx = document.getElementById("myChart");
      new Chart(ctx, {
        type: "line",
        data: this.data,
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              mode: "index",
            },
          },
          interaction: {
            mode: "nearest",
            axis: "x",
            intersect: false,
          },
          scales: {
            x: {
              title: {
                display: true,
                text: "Month",
              },
            },
            y: {
              stacked: false,
              title: {
                display: true,
                text: "Value",
              },
            },
          },
        },
      });
    });
  },
  computed: {},
  methods: {
    ...mapActions({
      getCapacityStatistics: "statistics/getCapacityStatistics",
    }),
    async handleGetCapacityStatistics() {
      this.isLoading = true;
      await this.getCapacityStatistics()
        .then((res) => {
          this.isLoading = false;
          this.data = res.data;
          // this.data.labels = [];

          function onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
          }

          res.data.labels.forEach((obj, key) => {
            // console.log(moment(obj).format("YYYY.MM.DD"));
            this.data.labels[key] = moment(obj).format("YYYY.MM.DD");
          });
          this.data.labels = this.data.labels.filter(onlyUnique);
          res.data.datasets.forEach((obj, key) => {
             const randColor = "#" +
              (((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0");
            this.data.datasets[key]["borderColor"] = randColor;
            this.data.datasets[key]["backgroundColor"] = randColor + "85";
            this.data.datasets[key]["fill"] = true;
            this.data.datasets[key]["pointStyle"] = false;
          });

          var ctx = document.getElementById("canvas");
          new Chart(ctx, {
            type: "line",
            data: this.data,
            options: {
              responsive: true,
              plugins: {
                tooltip: {
                  mode: "index",
                },
                legend: {
                  position: "right",
                },
              },
              interaction: {
                mode: "nearest",
                axis: "x",
                intersect: false,
              },
              scales: {
                x: {
                  title: {
                    display: false,
                    text: "Month",
                  },
                  ticks: {
                    autoSkip: false,
                    maxRotation: 60,
                    minRotation: 60,
                  },
                  grid: {
                    display: false,
                  },
                },
                y: {
                  stacked: false,
                  title: {
                    display: false,
                    text: "Value",
                  },
                },
              },
            },
            plugins: [
              {
                afterDraw: (chart) => {
                  if (chart.tooltip?._active?.length) {
                    let x = chart.tooltip._active[0].element.x;
                    let yAxis = chart.scales.y;
                    let ctx = chart.ctx;
                    ctx.save();
                    ctx.beginPath();
                    ctx.moveTo(x, yAxis.top);
                    ctx.lineTo(x, yAxis.bottom);
                    ctx.lineWidth = 1;
                    ctx.strokeStyle = "#a3a3a3";
                    ctx.stroke();
                    ctx.restore();
                  }
                },
              },
            ],
          });

          console.log(this.data);
        })
        .catch((error) => {
          this.isLoading = false;
          this.response = error.getMessage;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#canvas {
  position: relative;
  min-height: auto;
  width: 100%;
  display: flex;
  flex-grow: 1;
}

.chart-section {
  margin: 0 auto;
  height: auto;
}
</style>
